var t = /* @__PURE__ */function (l) {
  return l.VERTICAL = "vertical", l.SPLIT = "split", l.HORIZONTAL = "horizontal", l;
}(t || {});
export { t as l };